
import { RevSkeleton } from '@ds/components/Skeleton'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import RecommendedProductsBlock from '@recommendation/components/RecommendedProductsBlock/RecommendedProductsBlock.vue'
import { PRODUCT_SOURCE_TYPE } from '@tracking'

import translations from './RecommendationsBlock.translations'

export default {
  components: {
    RecommendedProductsBlock,
    RevSkeleton,
  },
  data() {
    return {
      showRecoTitle: false,
      showReco: true,
      showCrossSellTitle: false,
      showCrossSell: true,
      loadingReco: true,
      loadingCrossSell: true,
    }
  },
  computed: {
    ...mapGetters({
      country: 'config/country',
      experiments: 'flags/getExperiments',
    }),

    translations: () => translations,
    PP_RECOS_1: () => PRODUCT_SOURCE_TYPE.PP_RECOS_1,
    PP_RECOS_2: () => PRODUCT_SOURCE_TYPE.PP_RECOS_2,
    showBlock() {
      return this.showReco || this.showCrossSell
    },

    productId() {
      return this.$route.params.uuid
    },

    withGrade() {
      return this.experiments.recoInGrade === 'recoInGradeExcellent'
    },
  },
  methods: {
    handleRecoLoaded(results) {
      if (isEmpty(results)) {
        this.showReco = false
        this.showRecoTitle = false
        this.loadingReco = false
      } else {
        this.showRecoTitle = true
        this.showReco = true
        this.loadingReco = false
      }

      this.$emit('loaded', results)
    },

    handleCrossSellLoaded(results) {
      if (isEmpty(results)) {
        this.showCrossSell = false
        this.showCrossSellTitle = false
        this.loadingCrossSell = false
      } else {
        this.showCrossSell = true
        this.showCrossSellTitle = true
        this.loadingCrossSell = false
      }
    },
  },
}
